// /* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { FC } from "react";
import { toAbsoluteUrl } from "../../../helpers";
import { useLang, setLanguage } from "../../../i18n/Metronici18n";
import { useDispatch, useSelector } from "react-redux";
import { AppState, LANGUAGE } from "../../../../redux/types";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const languages = [
	{
		lang: "en",
		name: "English",
		flag: toAbsoluteUrl("/media/flags/united-states.svg"),
	},
	{
		lang: "kor",
		name: "Korean",
		flag: toAbsoluteUrl("/media/flags/south-korea.svg"),
	},
];

const Languages: FC = () => {
	const dispatch = useDispatch();
	const language = useSelector((state: AppState) => state.language);
	//console.log("language from redux store ", language);
	const lang = useLang();
	const currentLanguage = languages.find((x) => x.lang === lang);
	//console.log("current Language", currentLanguage);

	return (
		<div className='menu-item px-5 language_panel' data-kt-menu-trigger='hover' data-kt-menu-placement='left-start' data-kt-menu-flip='bottom'>
			<Link to='#' className='menu-link px-5'>
				<span className='menu-title position-relative'>
					Language
					<span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
						{language?.name} <img className='w-15px h-15px rounded-1 ms-2' src={language?.flag} alt='metronic' />
					</span>
				</span>
			</Link>

			<div className='menu-sub menu-sub-dropdown w-175px py-4'>
				{languages.map((l) => (
					<div
						className='menu-item px-3'
						key={l.lang}
						onClick={() => {
							setLanguage(l.lang);
							Swal.fire({
								icon: "success",
								title: `Switched to ${l.name}`,
							});
							const details = {
								lang: l.lang || null,
								name: l.name || null,
								flag: l.flag || null,
							};
							//console.log(details);
							localStorage.setItem("HQ_LANG_CHANGE_FLAG", "1");
							dispatch({
								type: LANGUAGE,
								payload: details,
							});
						}}>
						<Link to='#' className={clsx("menu-link d-flex px-5", { active: l.lang === language?.lang })}>
							<span className='symbol symbol-20px me-4'>
								<img className='rounded-1' src={l.flag} alt='metronic' />
							</span>
							{l.name}
						</Link>
					</div>
				))}
			</div>
		</div>
	);
};

export { Languages };
